import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { FunctionGroup } from 'src/app/_model/function-group';

@Injectable()
export abstract class FunctionGroupsDaoService implements Resetable {
  public abstract saveFunctionGroups(
    functionGroups: FunctionGroup[]
  ): Promise<void>;
  public abstract getFunctionGroups(): Promise<FunctionGroup[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
